
  export const TESTIMONIALS_RECEIVED = "TESTIMONIALS_RECEIVED";
  export const SET_TESTIMONIAL = "SET_TESTIMONIAL";
  export const CREATE_TESTIMONIAL = "CREATE_TESTIMONIAL";
  export const SET_PROPERTY_TESTIMONIAL = "SET_PROPERTY_TESTIMONIAL";
  